<template>
    <div>
      <background/>

      <h1>Test</h1>
      <layout-renderer page="home"/>
      dde
    </div>
</template>

<script>
    import Background from "./Background";
    import LayoutRenderer from "./LayoutRenderer";

    export default {
      components: {
        LayoutRenderer,
        Background},
      name: "test"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Test.vue